import { AST } from '@handlebars/parser';
import { createContentStatement } from 'modules/handlebars/domain/statement/utils';
import { StatementSerializer } from 'modules/handlebars/domain/statement/serializer';
import { getSnippetNameFromMustacheStatement } from 'modules/dynamicContentBuilder/utils';
import { removeScript } from 'utils/script';
import snippetIcon from '../assets/snippet.png';
import { createHandlebarsToken } from './createHandlebarsToken';

export const createSnippetTokenForMustacheStatement = (statement: AST.MustacheStatement) => {
  const underlyingHandlebarString = StatementSerializer.serialize(statement);
  const snippetName = getSnippetNameFromMustacheStatement(statement) ?? '';
  const escapedSnippetName = removeScript(snippetName);
  const token = createHandlebarsToken(escapedSnippetName, underlyingHandlebarString, snippetIcon);
  return createContentStatement(token);
};
